import { z } from 'zod/v4';

/**
 * Structural email validation shared across the client and server so the
 * front-end form check and the back-end send/resend guards can't drift.
 */
export const emailSchema = z.email();

/** Whether an address is a structurally valid email. */
export const isValidEmailAddress = (email: string): boolean =>
  emailSchema.safeParse(email).success;
